<template>
  <div class="wrapperswc">
    <div class="datecalendarbtn">
      <p>{{ currentMonth }} {{ currentYear }}</p>

      <img @click="$emit('calendarView')"
          src="/src/assets/images/calendar2.png"
          class="navigationItem">

    </div>
    <div class="item-mask"> 
      <div class="item-container" ref="itemcontainer">
        <div class="week-item" 
          :style="{'transform': `translateX(${week.position}px)` }"
          :key="getKeyForWeek(week.days)"
          :draggable="true"
          @dragstart="handleDragStart(index, $event)"
          @dragover="handleDragOver(index,week, $event)"
          @dragend="handleDragEnd(index,week, $event)"
          @touchstart.passive="handleTouchStart(index, $event)"
          @touchmove.passive="handleTouchMove(index,week, $event)"
          @touchend.passive="handleTouchEnd(index, week, $event)"
          :ref="getKeyForWeek(week.days)"
          v-for="(week,index) in visibleWeeks">
            <DayWeek
              :active="dia.value == activeday"
              :number=" dia.number"
              :label="dia.label"
              @click="$emit('showday', dia)"
              v-for="dia in week.days" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue';
import DayWeek from "@/components/smallWeekSlider/day.vue";
import { useDateUtils } from "./useDateUtils";

let formatterMonth = null;
let formatterYear = null;
const DRAGLEFT = -1;
const DRAGRIGHT = 1;
const MIN_POSITION_CHANGE_THRESHOLD = 50; // Adjust this value as needed


export default {
  name: 'SmallWeekSlider',
  props: ["selectedWeek", "activeday"],
  inject:["lang"],
  emits: ["showday", "calendarView","updateWeek"],
  components:{
    DayWeek
  },
  setup(props){
    const lang = inject('lang');
    let { addOneDay, getDayObject, getPrevious2Week, getNumberWeekDay } = useDateUtils(lang.value);
    return {
      addOneDay, 
      getDayObject,
      getPrevious2Week, 
      getNumberWeekDay
    }
  },
  data() {
    return {
      weeks: [],
      weeksize: 0,
      dragStartX: 0,
      draggedIndex: 0,
      currentXPosition: 0,
      progress: 0,
      isDragging: false,
    }
  },
  created(){
    const idioma = this.lang == "pt" ? "pt-PT" : "en-uk" ;
    formatterMonth =  new Intl.DateTimeFormat(idioma, {
      month: "long",
    });
    formatterYear = new Intl.DateTimeFormat(idioma, {
      year: "numeric",
    });
  },
  computed: {
    firstWeek(){
      const sortedWeeks = [...this.weeks];
      sortedWeeks.sort((a, b) => a.position - b.position);
      return sortedWeeks[0];
    },
    lastWeek(){
      const sortedWeeks = [...this.weeks];
      sortedWeeks.sort((a, b) => a.position - b.position);
      return sortedWeeks[sortedWeeks.length - 1];
    },
    visibleWeeks() {      
      const sortedWeeks = [...this.weeks];
      sortedWeeks.sort((a, b) => a.position - b.position);
      let closestIndex = -3;
      let closestDiff = Infinity;
      sortedWeeks.forEach((week, index) => {
        const diff = Math.abs(week.position - this.progress);
        if (diff < closestDiff) {
          closestDiff = diff;
          closestIndex = index;
        }
      });
      return sortedWeeks.slice(Math.max(closestIndex - 2, 0), closestIndex + 3);
    },
    currentMonth(){
      if(this.visibleWeeks.length == 0){
        return ""
      }
      const day = this.visibleWeeks[2].days[0].date;
      return formatterMonth.format(day);
    },
    currentYear(){
      if(this.visibleWeeks.length == 0){
        return ""
      }
      const day = this.visibleWeeks[2].days[0].date;
      return formatterYear.format(day);
    },
  },
  mounted(){
    const week = document.querySelector(".item-container");
    this.weeksize = week.clientWidth;
    this.generateWeeksForHeader(this.selectedWeek.start);
    window.addEventListener("resize", this.updateWeekSize);
  },
  methods: {
    updateWeekSize(){
      const week = document.querySelector(".item-container");
      this.weeksize = week.clientWidth;
    },
    generateWeeksForHeader(firstDayOfStartingWeek) {
      let currentWeek = this.getPrevious2Week(firstDayOfStartingWeek);
      for (let index = -2; index < 3; index++) {
        let days = this.getDaysForWeek(currentWeek);
        let week = {
          days: days,
          position: this.calculateTranlateXValue(index)
        }
        this.weeks.push(week);
      }
    },
    getDaysForWeek(currentWeek){
      let days = [];
      for (var i = 0; i < 7; i++) {
        const numberWeekDay = this.getNumberWeekDay(i);
        const day = this.getDayObject(currentWeek,numberWeekDay);
        days.push(day);
        this.addOneDay(currentWeek);
      }
      return days;
    },
    calculateTranlateXValue(index){
      return this.weeksize * index;
      /*let factor = index == -1 ? 1 : index -1;
      return this.weeksize * factor;*/
    },
    handleTouchStart(index, event) {
        console.log("handleTouchStart");
        this.draggedIndex = index;
        this.dragStartX = event.touches[0].clientX;
    },
    handleTouchMove(index,week, event) {
        console.log("handleTouchMove");
        const dragDirection = event.touches[0].clientX < this.dragStartX ? DRAGLEFT : DRAGRIGHT;
        const dragDistance = Math.abs(event.touches[0].clientX - this.dragStartX);
        this.moveWeeks(week,dragDistance,dragDirection);
    },
    handleTouchEnd(index, week,event) {
        console.log("handleTouchEnd");
        const dragDistance = Math.abs(this.currentXPosition - this.dragStartX);
        // Determine if it's a drop event based on some threshold (e.g., 30px)
        if (dragDistance >= MIN_POSITION_CHANGE_THRESHOLD) {
          this.updateWeeksAfterChanging(week, event.changedTouches[0].pageX);
        }
    },
    handleDragStart(index, event) {
      this.isDragging = true;
      this.draggedIndex = index;
      this.dragStartX = event.clientX;
      event.dataTransfer.effectAllowed = "move";
      // Create a transparent image as the drag image
      var img = new Image();
      img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
      event.dataTransfer.setDragImage(img, 0, 0);
      // Update the cursor style
      document.body.style.cursor = 'none';
      event.dataTransfer.setData("text/html", event.target.innerHTML);
    },
    handleDragOver(index,week,event){
      event.preventDefault();
      event.stopPropagation();
      const dragDirection = event.clientX < this.dragStartX ? DRAGLEFT : DRAGRIGHT;
      const dragDistance = Math.abs(event.clientX - this.dragStartX);
      this.moveWeeks(week,dragDistance,dragDirection);
    },
    handleDragEnd(index,week,ev){
      if (this.isDragging) {
        this.isDragging = false;
        // Call handleDrop with the same arguments as handleDragEnd
        this.handleDrop(index, week, ev);
      }
    },
    moveWeeks(week,dragDistance,dragDirection){
      this.isDragging = true;
      let targetPosition = this.currentXPosition + (dragDistance * dragDirection);    
      let minPosition = week.position;
      let maxPosition = 0;
      if(dragDirection == DRAGRIGHT){
        //semana anterior
        maxPosition = week.position - this.weeksize;
        this.currentXPosition = this.clamp(targetPosition, minPosition, maxPosition) * -1;
      }else{
        //semana seguinte
        maxPosition = week.position + this.weeksize;
        const m = Math.abs(targetPosition);
        this.currentXPosition = this.clampmax(m, minPosition, maxPosition) * -1;
      }
      requestAnimationFrame(() => {
        this.$refs.itemcontainer.style.transform = `translateX(${this.currentXPosition}px)`;
      });
    },
    updateWeeksAfterChanging(currentWeek, deltaX){
      this.progress = this.currentXPosition * -1;
      const dragDirection = deltaX < this.dragStartX ? DRAGLEFT : DRAGRIGHT;
      const dragDistance = Math.abs(deltaX - this.dragStartX);

      if (dragDistance > MIN_POSITION_CHANGE_THRESHOLD) {
        let positionChange = 0;
        let firstDayOfWeek = null;
        if (dragDirection === DRAGLEFT) {
          positionChange = this.lastWeek.position + this.weeksize;
          firstDayOfWeek = new Date(this.lastWeek.days[0].date);
          firstDayOfWeek.setDate(firstDayOfWeek.getDate() + 7);
        } else {
          firstDayOfWeek = new Date(this.firstWeek.days[0].date);
          firstDayOfWeek.setDate(firstDayOfWeek.getDate() - 7);
          positionChange = this.firstWeek.position - this.weeksize;
        }
        const updatedWeek = {
          days: this.getDaysForWeek(firstDayOfWeek),
          position: positionChange
        };
        this.weeks.push(updatedWeek);
        this.$emit('updateWeek',this.visibleWeeks[2]);
      } else {
        this.resetCurrenPositionToWeeksPosition(currentWeek);
      }
      this.$refs.itemcontainer.style.transform = `translateX(${this.currentXPosition}px)`;
    },
    resetCurrenPositionToWeeksPosition(week){
      this.currentXPosition = week.position * -1;
      this.progress = this.currentXPosition * -1;
    },
    handleDrop(index, week, ev) {
      ev.preventDefault();
      this.updateWeeksAfterChanging(week,ev.clientX);
    },
    clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    },
    clampmax(value, min, max) {
      return Math.max(Math.min(value, max), min);
    },
    getKeyForWeek(week){
      return `week${week[0].date.getTime()}`;
    }
  }
}
</script>


<style scoped>

.btn{
  display: none;
}

@media (hover: hover) {
  .btn{
    display: block;
    position: absolute;
    right: -10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .btn.left{
    left: -10px;
  }
}

.wrapperswc {
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 15px;
  padding-bottom: 20px;
  background: #f3f4f6;
}

.datecalendarbtn {
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
  margin-bottom: 10px;
}

p {
  font-family: "Montserrat";
  color: black;
  margin-bottom: 0;
  text-transform: capitalize;
}

.navigationItem {
  height: 27px;
}

.calendar {
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  width: 100%;
  position: relative;
}

.calendar::-webkit-scrollbar {
  width: 0rem;
  height: 0rem;
  background-color: transparent;
}


.item-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  transform-style: preserve-3d; /* enables 3D transformations on child elements */
  transition: transform .8s ease-in-out;
  height: 40px;
  overflow-x: visible;
  transform: translateX(0);
}

.week-item {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: row;
  user-select: none;
}

.item-mask {
 overflow: hidden;
}





</style>